<template>
  <div v-if="self.isShow" class="full-screen-popup column">
    <div class="selectStoreTitle row flex-center">
      <div class="iconfont icon-arr backicon" @click="backClick()"></div>
      <span class="titleGeay" v-if="titleGeay != ''">{{ titleGeay }}</span>
      {{ showTitle }}
    </div>

    <div class="searchbar row flex-center">
      <div class="flex-1">
        <van-search
          placeholder="输入要搜索的姓名"
          @search="onSearch"
          v-model="searchContent"
        >
        </van-search>
      </div>
      <div class="addnew" @click="onSearch()">搜索</div>
    </div>

    <div class="overflow-y flex-1 listScroll" id="selectPatientList">
      <div
        class="userItem"
        v-for="(row, index) in searchlist"
        :key="index"
        @click="slecntPatient(row)"
      >
        <div class="row flex-bottom">
          <div class="name">{{ row.patientName }}</div>

          <div class="sex">
            {{ row.sex == 1 ? "男" : row.sex == 2 ? "女" : "未知" }}
          </div>

          <div class="birth">{{ row.birthday }}</div>
        </div>

        <div class="linebot first row felx-center">
          <div class="left">病历号:</div>
          <div class="flex-1 right">{{ row.medicalNo }}</div>
        </div>

        <div class="linebot row felx-center">
          <div class="left">手机号:</div>
          <div class="flex-1 right">{{ row.phone }}</div>
        </div>

        <div class="linebot row felx-center">
          <div class="left">归属门店:</div>
          <div class="flex-1 right">{{ row.clinicName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPatientList } from "@/api/patient.js";
import { loadingStore } from "@/store/loading.js";
import func from "@/util/func.js";

export default {
  name: "selectPatient",
  props: {
    self: {
      type: Object,
      required: false,
      default: () => ({
        isShow: false,
        clinicId: "",
        current: "",
      }),
    },
  },
  components: {},
  data() {
    return {
      isLoading: false,
      isEnd: false,
      isSearch: false,
      pages: {
        current: 1,
        size: 10,
      },
      searchContent: "",
      sortValues: "",
      searchlist: [],
    };
  },
  setup(props) {
    let loading = loadingStore();
    let showTitle = "选择患者";
    let titleGeay = "";
    if (!func.isEmpty(props.self.title)) {
      titleGeay = props.self.title;
    }

    return {
      loading,
      titleGeay,
      showTitle,
    };
  },
  mounted() {
    let that = this;

    that.loaderList();

    this.loaderMore("selectPatientList", function () {
      that.loaderList();
    });
  },
  methods: {
    backClick() {
      this.self.isShow = false;
    },
    loaderMore(id = "scrollContent", loaderFn) {
      //监听页面上 id 为 id的元素 如果滚动到底部则执行加载方法 loaderFn
      //todo :可能方法要完善
      let that = this;
      const element = document.getElementById(id);
      element.addEventListener("scroll", () => {
        // 判断是否滚动到底部
        const isAtBottom =
          element.scrollTop + element.clientHeight >= element.scrollHeight - 20;

        if (isAtBottom && !that.isloading && !that.isFinish) {
          // 执行加载方法 loaderFn
          loaderFn();
        }
      });
    },
    loaderList() {
      let that = this;

      if (that.isLoading || that.isEnd) {
        return false;
      }

      let { pages } = that;

      let subdata = {
        search: that.searchContent,
        clinicId: "",
        sortValues: that.sortValues,
        ...pages,
      };

      that.isLoading = true;
      that.loading.showLoading();
      


      getPatientList(subdata).then((res) => {
        that.loading.hideLoading();

        that.isLoading = false;
        that.isSearch = true;
        that.pages.current++;

        let { records } = res.data.data;

        if (records.length > 0) {
          that.sortValues = records[records.length - 1].id;
        }

        records.forEach((item) => {
          that.searchlist.push(item);
        });

        if (records.length < that.pages.size) {
          that.isEnd = true;
        }
      });
    },
    slecntPatient(row) {
      let that = this;
      that.$emit("select", row);
      that.backClick();
    },
    onSearch() {
      let that = this;
      that.isEnd = false;
      that.searchlist = [];
      that.sortValues = "";
      that.pages.current = 1;
      that.loaderList();
    },
  },
};
</script>

<style scoped lang="scss">
.full-screen-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 8;
  background-color: #f6f6f6;
  animation: rightin 0.3s forwards;
  -webkit-animation: rightin 0.3s forwards;
}

.selectStoreTitle {
  padding: 0.217rem 0.208rem 0.217rem 0.208rem;
  font-size: 0.292rem;
  text-align: left;
  background-color: #fff;
  .backicon {
    font-size: 0.375rem;
    color: #28b8c3;
    padding: 0 0.15rem;
  }
}

.searchbar {
  margin-top: 0.15rem;
  background-color: #fff;
  .addnew {
    color: #28b8c3;
    font-size: 0.292rem;
    margin-right: 0.417rem;
  }
}

.listScroll {
  background-color: #f6f6f6;
  margin-top: 0.15rem;
}

.titleGeay {
  color: #999;
}

.userItem {
  background-color: #fff;
  box-sizing: border-box;
  padding: 0.333rem;
  font-size: 0.292rem;
  margin-bottom: 0.208rem;
  .name {
    font-size: 0.333rem;
    color: #212121;
  }

  .sex {
    font-size: 0.292rem;
    color: #212121;
    margin-left: 0.167rem;
  }

  .birth {
    font-size: 0.292rem;
    color: #212121;
    margin-left: 0.167rem;
  }

  .linebot {
    margin-top: 0.125rem;
    &.first {
      margin-top: 0.26rem;
    }
    .left {
      width: 1.667rem;
      color: #999999;
      text-align: left;
    }
    .right {
      color: #666666;
      text-align: left;
    }
  }
}
</style>